
import $ from "jquery";

import StickyApiSideBar from "../StickyApiSideBar";
new StickyApiSideBar;

const ApiExplorer = require('./api.explorer').ApiExplorer;
//const Ace = require('ace-builds/src-noconflict/ace');
//const modeJavascript = require("ace-builds/src-noconflict/mode-javascript");
//const themeGithub = require('ace-builds/src-noconflict/theme-github');

export class ApiDoc {
    options = {

    };

    constructor(options) {
        this.options = $.extend(this.options, options);
        this.initExplorer();
        this.initSbmDocFilter();
        this.initSbmDeveloperApi();
    };

    initExplorer(){
        var apiExplorer = new ApiExplorer();
    }

    initSbmDocFilter() {
        var $sbmDocSrch = $('#api-doc-search');
        var $sbmList = $('.user-api-doc li[data-method]');

        $sbmDocSrch.on('keyup', function () {
            var value = $(this).val().toLowerCase();

            if (value === "") {
                $sbmList.show();
            } else {
                $sbmList.each(function () {
                    var target = $(this).data('method');
                    target = target.toLowerCase();
                    (target.indexOf(value) >= 0 ) ? $(this).show() : $(this).hide();
                });
            }
        });

        //scroll to id
        let apiSidebarMenuLinks = $(".stixty-content a");
        apiSidebarMenuLinks.click(function(e){
            apiSidebarMenuLinks.removeClass('active');
            $(this).addClass('active');
            let section = $(this).attr("href");
            let menuHeight = $(".header--settings-block").outerHeight();
            let distance = ($(section).offset().top - menuHeight) - 30;
            $("html, body").animate({scrollTop: distance}, 1000);
        });

    };

    initSbmDeveloperApi () {
        var instance = this;
        //var urlTempl = "/api/developer-api/tab/{tabname}";

        jQuery(document).on('click', '.developer-tab-switch .tab-switcher--header-item a', function (e) {
            var tabId = jQuery(this).closest('.tab-switcher--header-item').data('tab');
            var tabUrl = jQuery(this).attr('href');

            if(tabId && tabUrl){
                instance.showTab(tabId);
                history.pushState({
                    tab : tabId
                }, null, tabUrl);
            }

            new StickyApiSideBar;

            e.preventDefault();
            return false;
        });

        jQuery(window).bind('popstate', function (event) {
            var state = event.originalEvent.state;

            if (jQuery.type(state) !== 'undefined' && state && state.tab) {
                instance.showTab(state.tab);
            }
        });

    }

    showTab (tabId) {
        var nodeContainer = jQuery(".developer-tab-switch");
        var tabsode = nodeContainer.find('.developer-tab-switch .tab-switcher--header-item');
        tabsode.removeClass('active');
        tabsode.find('a').filter(function(){
            return jQuery(this).data('tab') === tabId;
        }).closest('.tab-switcher--header-item').addClass('active');

        nodeContainer.find('.wrap-tabs.api--tabs api--tab-item').removeClass('in');
        jQuery('.' + tabId).addClass('in');
    }
}